/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceAccountDetailsField {
    created_by = 'created_by',
    created_at = 'created_at',
    updated_by = 'updated_by',
    updated_at = 'updated_at',
    parent_id = 'parent_id',
    source_account_id = 'source_account_id',
    billing_account_id = 'billing_account_id',
    resource_service_account_id = 'resource_service_account_id',
    tenant_id = 'tenant_id',
    name = 'name',
    description = 'description',
    currency = 'currency',
    use_in_self_service = 'use_in_self_service',
    status = 'status',
    keystone_tenant_id = 'keystone_tenant_id',
    scope = 'scope',
    onboarding_type = 'onboarding_type',
    onboarded_features = 'onboarded_features',
    native_details = 'native_details',
    credentials = 'credentials',
    credentials_temp = 'credentials_temp',
    custom_tags = 'custom_tags',
    assessment_details = 'assessment_details',
    governance_configuration = 'governance_configuration',
    is_active_in_cloud = 'is_active_in_cloud',
    skip_access_validation = 'skip_access_validation'
}
